import { colorNames } from './colors'

export const dealTeams = {
  sales: {
    label: 'Sales',
    nickname: 'HEO',
    color: colorNames.midnightBlue,
    teamIndex: 1,
  },
  processing: {
    label: 'Processing',
    nickname: 'TS',
    color: colorNames.studioPurple,
    teamIndex: 2,
  },
  underwriting: {
    label: 'Underwriting',
    nickname: 'VA',
    color: colorNames.red,
    teamIndex: -1,
  },
  valuations: {
    label: 'Valuations',
    nickname: 'VA',
    color: colorNames.pinkSalmon,
    teamIndex: 3,
  },
  uam: {
    label: 'UAM',
    nickname: 'PM',
    color: colorNames.jadeGreen,
    teamIndex: 4,
  },
  closing: {
    label: 'Closing',
    nickname: 'CL',
    color: colorNames.blazeOrange,
    teamIndex: 5,
  },
  'post-closing': {
    label: 'Post Closing',
    nickname: 'PC',
    color: colorNames.harlequin,
    teamIndex: 6,
  },
  'ts-round-robin': {
    label: 'TS Round Robin',
    nickname: 'RB',
    color: colorNames.graySolid,
    teamIndex: -1,
  },
}
